import { render } from "./UploadTransferStatement.vue?vue&type=template&id=ebb7b0da"
import script from "./UploadTransferStatement.vue?vue&type=script&lang=js"
export * from "./UploadTransferStatement.vue?vue&type=script&lang=js"

import "./UploadTransferStatement.vue?vue&type=style&index=0&id=ebb7b0da&lang=css"

import exportComponent from "/codebuild/output/src1003992750/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__